module.exports = __webpack_public_path__ + "img/1.4607e7b3.jpg";